import type { ReactNode } from "react";
import { cx } from "../cx";

/**
 * Full-height column: the nav, an optional Banner strip, then the body.
 * `layout="page"` pads the body like the card screens; `flush` hands the
 * body to a Rail plus content pair without padding (Review).
 */
export function AppShell({
  nav,
  banner,
  children,
  layout = "page",
  className = "",
}: {
  nav: ReactNode;
  banner?: ReactNode;
  children: ReactNode;
  layout?: "page" | "flush";
  className?: string;
}) {
  return (
    <div
      data-component="AppShell"
      className={cx(
        "flex flex-col bg-ground",
        layout === "flush" ? "h-dvh overflow-hidden" : "min-h-screen",
        className,
      )}
    >
      {nav}
      {banner}
      <main
        className={cx(
          "flex min-h-0 flex-1",
          layout === "page" ? "gap-6 px-4 py-5 sm:px-6 xl:px-10 xl:py-7" : "flex-row",
        )}
      >
        {children}
      </main>
    </div>
  );
}
